/* tslint:disable */
/* eslint-disable */
export enum WorkDocumentTemplateSelectorEnum {
  All = 'all',
  ProjectForm = 'project_form',
  Contact = 'contact',
  Debtor = 'debtor',
  Selfservice = 'selfservice',
  Foerderung = 'foerderung'
}
